export class AuthorizationCodeExpiredException extends Error {
  constructor(message) {
    super('Authentication through google failed. Please try again.');
  }
}